export default "__VITE_ASSET__aSh$HYih__"